enum MessageBoxType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
export default MessageBoxType;
